<!-- GameThemeSection.vue -->
<template>
  <section class="slot-theme xs-section">
    <div class="grid-container">
      <swiper class="swiper jackpot-swiper" :options="themeSwiperOption">
        <swiper-slide
          class="slot-slide swiper-slide"
          v-for="list in getGameList"
          :key="list.id"
        >
        <div class="theme-select" :class="{active : selectedThemeId === list.id}" @click="changeTheme(list.id)">
          <img :src="list.imagePath" :alt="list.name" />
        </div>
          <!-- <input
            type="radio"
            v-model="selectedThemeId"
            :id="'game-' + index"
            name="game-theme"
            :value="list.id"
            @change="updateTheme"
          />
          <label class="game-theme" :for="'game-' + index">
            <img :src="list.imagePath" :alt="list.name" />
          </label> -->
        </swiper-slide>
      </swiper>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

import { mapActions, mapGetters } from "vuex";
import { GameNamespace, GameActions } from "@/store/game";
import pageMixin from "@/mixins/pageMixin";

export default {
  name: "GameThemeSection",
  mixins: [pageMixin],
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      selectedThemeId: this.getSelectedTheme,
      themeSwiperOption: {
        slidesPerView: "auto",
        spaceBetween: 5,
        observer: true,
        observeParents: true,
        grapCursor: true,
      },
    };
  },
  computed: {
    ...mapGetters(GameNamespace, ["getGameList"]),
    gameList() {
      return this.getGameList || []; // 게임 리스트가 없을 때 빈 배열 반환
    },

    // 기존 gameList를 filteredMachineList 기준으로 필터링
    filteredGameList() {
      if (!this.getFilteredMachineList) return this.getGameList || [];

      const filteredIds = this.getFilteredMachineList.map(
        (machine) => machine.gameId,
      );
      return this.getGameList.filter((game) => filteredIds.includes(game.id));
    },
  },
  mounted() {
    this.ACTION_READ_GAME_LIST();
  },
  methods: {
    ...mapActions(GameNamespace, {
      ACTION_READ_GAME_LIST: GameActions.ACTION_READ_GAME_LIST,
    }),
    changeTheme(newVal) {
      if(this.selectedThemeId !== newVal){
        this.selectedThemeId = newVal;
      }else{
        this.selectedThemeId = "all";
      }

      this.updateSelectedTheme(this.selectedThemeId);
    },
  },
};
</script>
